// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__L94RL","col":"styles_col__Sr93M"};